import React from 'react'
import { Table } from 'widgets/crud'
import PendingOrderColumns from './columns/PendingOrderColumns'
import ForEachOrderItemCategory from 'pages/app/inventory/order/partials/ForEachOrderItemCategory'

export default function PendingOrderItems () {
  return (
    <ForEachOrderItemCategory>
      <Table>
        <PendingOrderColumns />
      </Table>
    </ForEachOrderItemCategory>
  )
}
